// extracted by mini-css-extract-plugin
module.exports = {"container":"UserNotificationsList__container___VznF0","isLoading":"UserNotificationsList__isLoading___aHUgA","isPending":"UserNotificationsList__isPending___-yiUd"};